export const STORAGE_KEY_PREFIX = '@@crowdaa@@';
